import 'bootstrap/dist/css/bootstrap.css';
import { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import  linkedIn from '../assets/img/linkein.svg';
import { Link } from 'react-scroll';
import github from '../assets/img/github.webp';



export const NavBar = ({ onLoad }) => {

    const [activeLink, setActiveLink] = useState('home')
    const [scrolled, setScroll] = useState(false)

    useEffect(() => {
        const onScroll = () => {
            if(window.scrollY > 50) {
                setScroll(true)
            } else {
                setScroll(false)
            }
        }
        window.addEventListener('scroll', onScroll)

    }, [])

    const changeActiveLink = (link) => {
        setActiveLink(link)
    }


    return (
        <Navbar expand="lg" className={scrolled ? 'scrolled' : ''}>
            <Container>
                <Navbar.Brand href="#home">
                    <img onLoad={ onLoad } src='' alt="logo"  />
                </Navbar.Brand>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link href="#home" 
                            className={activeLink === "home" ? 'active navbar-link': ' navbar-link'} 
                            onClick={() => changeActiveLink('home')}>
                            Home
                        </Nav.Link>
                        <Nav.Link href="#skills" 
                            className={activeLink === "skills" ? 'active navbar-link': ' navbar-link'} 
                            onClick={() => changeActiveLink('skills')}>
                            Skills
                        </Nav.Link>
                        <Nav.Link href="#languages" 
                            className={activeLink === "languages" ? 'active navbar-link': ' navbar-link'} 
                            onClick={() => changeActiveLink('languages')}>
                            Tecnologías
                        </Nav.Link>       
                    </Nav>
                    <span className="navbar-text">  
                        <div className="social-icon">
                            <a href="https://www.linkedin.com/in/orestes-o-932b8b44/" target="_blank" rel="noreferrer">
                                <img  onLoad={ onLoad } src={linkedIn} alt="linkedin" ></img>
                            </a>
                        </div>
                        <div className="social-icon">
                            <a href="https://github.com/orestes7054" target="_blank" rel="noreferrer">
                                <img onLoad={ onLoad } src={github} alt="github"></img>
                            </a>
                        </div>
                    </span>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}